export default "__VITE_ASSET__Drd7Vkxv__"